export class ChangerInitiateurDossier
{
    requestId: String;
    backupId: String;
}